import * as React from 'react'
import { translate } from 'react-translate'

class MdTable extends React.Component<MdTableProps, null> {

  constructor(props: any) {
    super(props)
  }
  public selectRow(row, key, e) {
    e.preventDefault()
    row.key = key
    this.props.onSelectRow(row)
  }

  public selectHeader(col, id, e) {
    e.preventDefault()
    this.props.onSelectHeader(col, id)
  }

  public render() {
    let t = this.props.t
    let dataset = this.props.dataset
    let header: MdTableHeader[] = this.props.header

    return (
      <div>
        <table className='table md-table'>
          <thead>
            <tr>
              {header.map((col, id) => {
                let style = {
                  width: col.width ? col.width : '',
                  maxWidth: col.width ? col.width : '',
                  textAlign: col.align ? col.align : 'left'
                }
                return (
                    <th
                      style={style}
                      className={'header ' +
                        (col.sortable ? 'sortable ' : ' ')
                        +
                        (col.sorted ? col.sorted : '')
                      }
                      key={id}
                      onClick={(e) => this.selectHeader(col, id, e)}>
                      {t(col.namedKey || col.key)}
                    </th>
                  )
              })}
            </tr>
          </thead>

          <tbody>
          {dataset.map((obj, id) => {
            return (
                <tr style={{cursor:'pointer'}} key={id} className={(this.props.selectedRow === id) ? 'active' : null} onClick={(e) => this.selectRow(obj, id, e)}>
                  {header.map((col, colId) => {
                    let style = {
                      width: col.width ? col.width : '',
                      maxWidth: col.width ? col.width : '',
                      textAlign: col.align ? col.align : 'left',
                      textOverflow: 'ellipsis'
                    }

                    return (
                        <td
                          key={id + '_' + colId}
                          style={style}
                        >{obj[col.key]}</td>
                      )
                  })}
                </tr>
              )
          })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default translate('MdTable')(MdTable)
export { MdTable as MdTableUnconnected }



// WEBPACK FOOTER //
// ./react/components/widgets/MdTable.tsx